import React from 'react';
import { GraduationCap, Users, DollarSign } from 'lucide-react';

/**
 * Компонент для параметров обучения персонала
 */
const TrainingSection = ({ 
  formData, 
  handleInputChange, 
  errors
}) => {
  if (!formData.trainingRequired) {
    return (
      <div className="mb-6">
        <div className="flex items-center justify-between">
          <label className="inline-flex items-center text-sm font-medium text-gray-700 dark:text-gray-300">
            <GraduationCap className="w-5 h-5 mr-2 text-green-500" />
            <span>Обучение персонала</span>
            <input
              type="checkbox"
              name="trainingRequired"
              checked={formData.trainingRequired}
              onChange={handleInputChange}
              className="form-checkbox ml-3"
            />
          </label>
        </div>
      </div>
    );
  }

  return (
    <div className="mb-6 bg-green-50 dark:bg-green-900/20 p-4 rounded-lg border border-green-200 dark:border-green-800">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-base font-medium text-gray-900 dark:text-white flex items-center">
          <GraduationCap className="w-5 h-5 mr-2 text-green-500" />
          Обучение персонала
        </h3>
        <label className="inline-flex items-center text-sm text-gray-700 dark:text-gray-300">
          <input
            type="checkbox"
            name="trainingRequired"
            checked={formData.trainingRequired}
            onChange={handleInputChange}
            className="form-checkbox"
          />
          <span className="ml-2">Включить в расчет</span>
        </label>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Интенсивность обучения */}
        <div>
          <label htmlFor="trainingIntensity" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Интенсивность обучения
          </label>
          <select
            id="trainingIntensity"
            name="trainingIntensity"
            value={formData.trainingIntensity}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.trainingIntensity ? 'input-error' : ''}`}
          >
            <option value="low">Базовое (вводный курс)</option>
            <option value="medium">Стандартное (полный курс)</option>
            <option value="high">Интенсивное (углубленное обучение)</option>
          </select>
          {errors.trainingIntensity && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.trainingIntensity}
            </p>
          )}
        </div>

        {/* Количество сотрудников для обучения */}
        <div>
          <label htmlFor="employeesToTrain" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Users className="w-4 h-4 mr-2 text-green-500" />
            Количество сотрудников
          </label>
          <input
            type="text"
            id="employeesToTrain"
            name="employeesToTrain"
            value={formData.employeesToTrain}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.employeesToTrain ? 'input-error' : ''}`}
            placeholder="Количество сотрудников"
          />
          {errors.employeesToTrain && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.employeesToTrain}
            </p>
          )}
        </div>

        {/* Стоимость обучения на сотрудника */}
        <div className="md:col-span-2">
          <label htmlFor="trainingCostPerEmployee" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <DollarSign className="w-4 h-4 mr-2 text-green-500" />
            Стоимость обучения на сотрудника (руб.)
          </label>
          <input
            type="text"
            id="trainingCostPerEmployee"
            name="trainingCostPerEmployee"
            value={formData.trainingCostPerEmployee}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.trainingCostPerEmployee ? 'input-error' : ''}`}
            placeholder="Стоимость на одного сотрудника"
          />
          {errors.trainingCostPerEmployee && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.trainingCostPerEmployee}
            </p>
          )}
        </div>
      </div>

      {/* Пояснения по обучению */}
      <div className="mt-4 bg-green-100 dark:bg-green-900/30 p-3 rounded-lg border border-green-200 dark:border-green-800">
        <p className="text-xs text-green-700 dark:text-green-300">
          <span className="font-medium">Совет:</span> Инвестиции в обучение персонала могут значительно повысить эффективность 
          трансформации бизнес-процессов. Помимо стоимости самого обучения, учтите косвенные расходы на время сотрудников 
          (отвлечение от основной работы) и возможную необходимость найма временных замен.
        </p>
      </div>
    </div>
  );
};

export default TrainingSection;